/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowAUpIcon64Regular = forwardRef('ArrowAUpIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M12.06 27.56a1.5 1.5 0 0 1-2.12-2.12L26.696 8.681a7.5 7.5 0 0 1 10.606 0l16.758 16.757a1.5 1.5 0 0 1-2.122 2.122L35.182 10.803A4.483 4.483 0 0 0 33.5 9.742V56a1.5 1.5 0 0 1-3 0V9.742c-.614.216-1.19.57-1.682 1.061L12.061 27.561Z" })));
});
